import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from '@honda-canada/design-system-react';
import RoutableSitecoreLink from '../RoutableSitecoreLink';
import { gtmEditAcccessory } from './utils/handleGtmEvents';
const handleOnClick = ({ linkText, linkUrl, gtmPayload, onClick }) => {
    gtmEditAcccessory({
        linkText,
        linkUrl: linkUrl || '',
        componentType: gtmPayload.componentType,
        model: gtmPayload.model,
        trim: gtmPayload.trim,
        gtmBodyStyle: gtmPayload.bodyStyle,
        inventoryStatus: gtmPayload.inventoryStatus,
    });
    if (onClick) {
        onClick();
    }
};
const CustomizationSummaryEditLink = ({ href, querystring, anchor, children, dataTestId, onClick, gtmPayload, isEdit = true, }) => (_jsx(Link, { href: true, as: RoutableSitecoreLink, field: {
        value: {
            href,
            anchor,
            linktype: 'internal',
            querystring,
        },
    }, styling: "tertiary2", size: "regular", ml: "s", onClick: () => handleOnClick({
        linkText: isEdit ? `edit: ${anchor}` : `add more ${anchor}`,
        linkUrl: `${href}?${querystring}`,
        gtmPayload,
        onClick,
    }), "data-testid": dataTestId || 'cy-customization-summary-edit-build', children: children }));
export default CustomizationSummaryEditLink;
